import Accordion from '@components/Accordion';
import BlankStamp from '@components/blank/BlankStamp';
import Column from '@components/Column';
import Divider from '@components/Divider';
import Header from '@components/Header';
import styled from '@emotion/styled';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import Fab from './components/Fab';
import StampCard from './components/StampCard';
import StampHeader from './components/StampHeader';
import StampNote from './components/StampNote';
import useStampCards from './hooks/useStampCards';

const StampsActivity: ActivityComponentType = () => {
    const { t } = useTranslation('stamp');
    const stampCards = useStampCards();
    return (
        <AppScreen>
            <Container fullWidth>
                <Header title={t('title')}/>
                <StampHeader/>
                <Contents fullWidth
                    as='section'
                    spacing={16}>
                    {stampCards?.cards.map((stampCard) => (
                        <StampCard stampCard={stampCard}
                            key={stampCard.shopId} />
                    ))}
                    {(stampCards?.cards.length || 0) < 1 && (
                        <BlankStamp/>
                    )}
                </Contents>
                <Divider/>
                <StampNote note={stampCards?.note}/>
                <Fab/>
            </Container>
        </AppScreen>
    );
};

const Container = styled(Column)`
    background-color: var(--color-gray1);
    min-height: 100vh;
    padding-bottom: 300px;
`;

const Contents = styled(Column)`
    padding: 0 44px 64px;
`;

export default StampsActivity;
